import React from 'react'
import {Block, Col} from 'jsxstyle'
import {XpertKnowledgeSectionDto} from '../../../services/XpertKnowledgeSection/type'
import XpertKnowledgeTutorialSubSection from './XpertKnowledgeTutorialSubSection'
import RichTextContent from '../../../components/RichTextContent'
import {useResponsiveBreakpoints} from '../../../hooks/mediaQueries'

interface XpertKnowledgeTutorialSectionProps {
  xpertKnowledgeSection: XpertKnowledgeSectionDto
}

const XpertKnowledgeTutorialSection: React.FC<XpertKnowledgeTutorialSectionProps> = ({xpertKnowledgeSection}) => {
  const {tablet, laptop} = useResponsiveBreakpoints()
  const subSections = xpertKnowledgeSection.subSections?.sort((a, b) => a.position - b.position) || []
  const subSectionCount = subSections.length

  return (
    <Col
      gap="20px"
      props={{id: `section-${xpertKnowledgeSection.id}`}}
      transition="all 0.3s ease"
      {...(!tablet && {
        gap: '16px',
      })}
    >
      <Block
        fontWeight={500}
        lineHeight="34px"
        fontSize="24px"
        transition="all 0.3s ease"
        {...(!tablet && {
          fontSize: '20px',
          lineHeight: '28px',
        })}
        {...(tablet &&
          !laptop && {
            fontSize: '22px',
            lineHeight: '31px',
          })}
      >
        {xpertKnowledgeSection.title}
      </Block>
      <Block
        fontWeight={400}
        fontSize="14px"
        lineHeight="22px"
        transition="all 0.3s ease"
        {...(!tablet && {
          fontSize: '13px',
          lineHeight: '20px',
        })}
      >
        <RichTextContent content={xpertKnowledgeSection.intro} />
      </Block>
      <Col
        gap="30px"
        transition="all 0.3s ease"
        {...(!tablet && {
          gap: '20px',
        })}
        {...(tablet &&
          !laptop && {
            gap: '24px',
          })}
      >
        {subSections?.map((subSection, index) => (
          <XpertKnowledgeTutorialSubSection
            key={subSection.id}
            sectionId={xpertKnowledgeSection.id}
            xpertKnowledgeSubSection={subSection}
            index={index}
            subSectionCount={subSectionCount}
          />
        ))}
      </Col>
      <Block
        fontWeight={400}
        fontSize="14px"
        lineHeight="22px"
        transition="all 0.3s ease"
        {...(!tablet && {
          fontSize: '13px',
          lineHeight: '20px',
        })}
      >
        <RichTextContent content={xpertKnowledgeSection.conclusion} />
      </Block>
    </Col>
  )
}

export default XpertKnowledgeTutorialSection
